import React from 'react'

const SpaceResponsive = props => {
  return <div style={{ height: `${props.height}px` }} />
}

export default SpaceResponsive
